import styled from 'styled-components';
import { Card } from '@shared/ui/Card';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(5)};
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Subtitle = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 2px;
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
`;

export const MetricBox = styled(Card)`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MetricLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const MetricValue = styled.div<{ $color?: string }>`
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: ${({ $color, theme }) => $color ?? theme.colors.text.primary};
`;

export const MetricNote = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 2px;
`;

export const TableWrap = styled(Card)`
  padding: 0;
  overflow: hidden;
  overflow-x: auto;
`;

export const RightTh = styled.th`
  text-align: right;
`;

export const RightTd = styled.td`
  text-align: right;
`;

export const TableNoticeTd = styled.td`
  text-align: center;
  padding: 20px;
`;

export const PeriodText = styled.div`
  font-weight: 700;
`;

export const DueWarningText = styled.div`
  font-size: 11px;
  color: #ef4444;
  font-weight: 600;
`;

export const BoldText = styled.span`
  font-weight: 600;
`;

export const DimSubText = styled.div`
  font-size: 11px;
  opacity: 0.75;
`;

export const ReservedPurpleTd = styled.td`
  text-align: right;
  color: #8b5cf6;
`;

export const PaidGreenTd = styled.td`
  text-align: right;
  color: #10b981;
`;

export const CounterpartyTitle = styled.div`
  font-weight: 700;
`;

export const InnSubText = styled.div`
  font-size: 11px;
  opacity: 0.7;
`;

export const RemainingRedTd = styled.td`
  text-align: right;
  font-weight: 800;
  color: #ef4444;
`;

export const IssuedDateText = styled.div`
  font-size: 10px;
  opacity: 0.65;
`;

export const RemainingSkyTd = styled.td`
  text-align: right;
  font-weight: 800;
  color: #38bdf8;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 400px;

  @media (max-width: 500px) {
    min-width: 100%;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Input = styled.input`
  padding: 8px 12px;
  border-radius: ${({ theme }) => theme.radius.sm};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 13px;
`;

export const Select = styled.select`
  padding: 8px 12px;
  border-radius: ${({ theme }) => theme.radius.sm};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 13px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const ModalFormFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
`;

export const AlertBanner = styled.div<{ $tone: 'success' | 'warning' }>`
  padding: 10px 16px;
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({ $tone }) =>
    $tone === 'success'
      ? 'background: rgba(16, 185, 129, 0.12); color: #10b981; border: 1px solid rgba(16, 185, 129, 0.3);'
      : 'background: rgba(245, 158, 11, 0.12); color: #f59e0b; border: 1px solid rgba(245, 158, 11, 0.3);'}
`;
